//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      value: ''
    };
  }
};